// extracted by mini-css-extract-plugin
export var columnList = "_f2-0";